import { PROJECT_STATUS } from "@/enums";

export const getProjectStatusLabelFromId = (statusId: string): string => {
  //check intake
  let status = Object.values(PROJECT_STATUS.intake).find(
    (status) => status.id === statusId
  );

  if (!status) {
    status = Object.values(PROJECT_STATUS.project).find(
      (status) => status.id === statusId
    );
  }

  return status?.translationId || "projectStatus.unknown";
};
